import { requestApi } from 'utils';

export const getZppCourseInfosApiRequest = () =>
  requestApi.query(`
    query ZppCourseInfos {
      zppCourseInfos {
        bonusAccessStatus
        completedAt
        courseGroup
        courseId
        courseStatus
        courseTeaser {
          backgroundColor
          courseId
          id
          pictureV2
          title
        }
        insuranceCompany {
          id
          name
          slug
        }
        endsAt
        id
        startedAt
        zppCourseAttendanceStatus
      }
    }`);
